var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',[(_vm.useSvg)?_c('img',{staticClass:"inline-svg",attrs:{"src":_vm.svgData}}):_c('img',{staticStyle:{"height":"1.25rem","width":"1.25rem"},attrs:{"src":_vm.imgPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }